import { AlertCircle, CheckCircle, XCircle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

type StatusType = 'billing' | 'situation' | 'general';

interface StatusBadgeProps {
  status: string;
  type?: StatusType;
  className?: string;
}

const getStatusConfig = (status: string, type: StatusType) => {
  const normalizedStatus = status.toLowerCase();

  // Billing status
  if (type === 'billing') {
    if (normalizedStatus === 'ativo' || normalizedStatus === 'adimplente') {
      return {
        variant: 'success' as const,
        icon: CheckCircle,
        color: 'bg-green-100 text-green-800 border-green-200',
      };
    }
    if (normalizedStatus === 'inadimplente') {
      return {
        variant: 'warning' as const,
        icon: AlertCircle,
        color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      };
    }
    if (normalizedStatus === 'bloqueado' || normalizedStatus === 'inativo') {
      return {
        variant: 'destructive' as const,
        icon: XCircle,
        color: 'bg-red-100 text-red-800 border-red-200',
      };
    }
  }

  // Situation status (IE)
  if (type === 'situation') {
    if (normalizedStatus === 'habilitada' || normalizedStatus === 'ativa') {
      return {
        variant: 'success' as const,
        icon: CheckCircle,
        color: 'bg-green-100 text-green-800 border-green-200',
      };
    }
    if (normalizedStatus === 'suspensa') {
      return {
        variant: 'warning' as const,
        icon: AlertCircle,
        color: 'bg-yellow-100 text-yellow-800 border-yellow-200',
      };
    }
    if (normalizedStatus === 'cancelada' || normalizedStatus === 'baixada') {
      return {
        variant: 'destructive' as const,
        icon: XCircle,
        color: 'bg-red-100 text-red-800 border-red-200',
      };
    }
  }

  // General status
  if (normalizedStatus === 'ativo' || normalizedStatus === 'ativa') {
    return {
      variant: 'success' as const,
      icon: CheckCircle,
      color: 'bg-green-100 text-green-800 border-green-200',
    };
  }

  // Default
  return {
    variant: 'secondary' as const,
    icon: AlertCircle,
    color: 'bg-gray-100 text-gray-800 border-gray-200',
  };
};

export function StatusBadge({ status, type = 'general', className }: StatusBadgeProps) {
  const config = getStatusConfig(status, type);
  const Icon = config.icon;

  return (
    <Badge variant="outline" className={cn('gap-1 font-medium', config.color, className)}>
      <Icon className="h-3 w-3" />
      {status}
    </Badge>
  );
}
